export const KEY_VERSION = 'calcuso_go_app_version';
export const CURRENT_VERSION = '1.0.6';

